export class CompletaRegistrazione {
    anzianitaServizioIstituto?: number;
    anzianitaServizio?: number;
    docenteTitoloDiStudio?: string;
    docenteSpecializzazioni?: Array<string>;
    password?: string;
    photoUrl?: string;
    ruolo?: boolean;
}